function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2692",
  width: 32,
  height: 32,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2103",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2316",
  d: "M23.14,6.4h-.49V5.91a1.483,1.483,0,0,0-1.48-1.48H8.86A1.483,1.483,0,0,0,7.38,5.91V24.12A1.483,1.483,0,0,0,8.86,25.6h.49v.49a1.483,1.483,0,0,0,1.48,1.48H23.14a1.483,1.483,0,0,0,1.48-1.48V7.88A1.483,1.483,0,0,0,23.14,6.4M8.86,24.62a.5.5,0,0,1-.49-.5V5.91a.491.491,0,0,1,.49-.49H21.17a.491.491,0,0,1,.49.49V21.17H19.69a1.475,1.475,0,0,0-1.47,1.48v1.97Zm12.11-2.47L19.2,23.92V22.65a.493.493,0,0,1,.49-.5Zm2.66,3.94a.491.491,0,0,1-.49.49H10.83a.491.491,0,0,1-.49-.49V25.6h8.37a.518.518,0,0,0,.35-.14l3.44-3.45a.511.511,0,0,0,.125-.235.32.32,0,0,0,.007-.033.4.4,0,0,0,.018-.082V7.38h.49a.5.5,0,0,1,.49.5Z",
  fill: "#69687e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2317",
  d: "M19.815,11.323h-9.6a.37.37,0,0,1-.369-.37v-.246a.369.369,0,0,1,.369-.369h9.6a.369.369,0,0,1,.369.369v.246a.37.37,0,0,1-.369.37",
  fill: "#69687e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2318",
  d: "M19.815,13.292h-9.6a.369.369,0,0,1-.369-.369v-.246a.369.369,0,0,1,.369-.369h9.6a.369.369,0,0,1,.369.369v.246a.369.369,0,0,1-.369.369",
  fill: "#69687e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2319",
  d: "M15.383,15.265H10.216a.371.371,0,0,1-.37-.371v-.247a.37.37,0,0,1,.37-.37h5.167a.371.371,0,0,1,.371.37v.247a.371.371,0,0,1-.371.371",
  fill: "#69687e"
}));

var SvgDokumentyDlaMieszkanca = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2101",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDokumentyDlaMieszkanca, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dokumentyDlaMieszkanca.ade2efc7.svg";
export { ForwardRef as ReactComponent };